import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
  PAGE_TITLE_SIZES,
} from './HbPageTitleConstants';

import s from './hb-page-title.scss';

const HbPageTitle = ({
  className,
  TitleElement = 'h1',
  title,
  size = PAGE_TITLE_SIZES.SMALL ,
}) => {
  return (
    <div className={cx(s.root, className, s[size])}>
      <TitleElement data-test-id={TitleElement === 'h1' ? 'header-h1' : null} className={s.title}>
        {title}
      </TitleElement>
    </div>
  );
}

HbPageTitle.propTypes = {
  className: PropTypes.string,
  TitleElement: PropTypes.string,
  title: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.values(PAGE_TITLE_SIZES)),
};

export default HbPageTitle;
